import * as React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  DateField,
  FilterButton,
  TopToolbar,
  SelectColumnsButton,
  TextInput,
  EditButton,
  ShowButton,
  CreateButton,
  ReferenceField,
  ReferenceInput,
  SelectInput
} from 'react-admin'
import { Box } from '@mui/material'

const filters = [
  <TextInput label="Search Location Name" source="locationName" alwaysOn sx={{ width: '250px' }} resettable />,
  <ReferenceInput link="show" source="providerGroupId" reference="provider-groups" label="Provider Group" alwaysOn>
    <SelectInput optionText="name" emptyText="All Provider Groups" resettable sx={{ width: '250px' }} />
  </ReferenceInput>
]

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <CreateButton label="New Location" />
  </TopToolbar>
)

const ProviderLocationList = (props) => {
  return (
    <Box>
      <List
        {...props}
        filters={filters}
        actions={<ListActions />}
        sort={{ field: 'createdAt', order: 'DESC' }}
      >
        <DatagridConfigurable bulkActionButtons={false} rowClick="show">
          <TextField source="locationName" label="Location Name" />
          <ReferenceField link="show" source="providerGroupId" reference="provider-groups" label="Provider Group">
            <TextField source="name" />
          </ReferenceField>
          <DateField source="createdAt" label="Created At" showTime sortable={false} />
          <EditButton label="Edit" />
        </DatagridConfigurable>
      </List>
    </Box>
  )
}

export default ProviderLocationList
